import { useLocation, useNavigate } from '@remix-run/react'
import { OrganizationMember } from '@zenstackhq/runtime/models'
import {
  Flex,
  PaginationProps,
  Table,
  TablePaginationConfig,
  Typography,
} from 'antd'
import type { FilterValue, SorterResult } from 'antd/es/table/interface'
import { useMemo } from 'react'
import { OrganizationType } from '~/features/organization/common'
import { Toolbar } from './components/Toolbar'
import { useColumns } from './hooks/useColumns'
import { useData } from './hooks/useData'
import { useLogic } from './hooks/useLogic'

type Props = {
  organization: OrganizationType
  organizationMemberUser: OrganizationMember
}

export const TicketList = ({ organization, organizationMemberUser }: Props) => {
  const location = useLocation()

  const navigate = useNavigate()

  const data = useData({ organization })
  const logic = useLogic({ organization })

  const { columns } = useColumns({
    organizationMemberUser,
    onChange: async values => {
      await logic.update(values)
      await data.refetch()
    },
  })

  const handleTableChange = (
    pagination: TablePaginationConfig,
    filters: Record<string, FilterValue>,
    sorter: SorterResult<any> | SorterResult<any>[],
  ) => {
    data.setPageIndex(pagination.current)
  }

  const paginationAnt = useMemo(() => {
    const item: PaginationProps = {
      ...data.pagination,
      showSizeChanger: false,
    }

    return item
  }, [data.pagination])

  return (
    <>
      <Flex vertical className="w-full">
        <Flex className="p-2" align="center" gap={16}>
          <Typography.Title level={1} style={{ margin: 0 }}>
            Tickets
          </Typography.Title>

          <Flex flex={1} justify="right">
            <Toolbar
              countTickets={data.pagination.total}
              filters={data.filters}
              onChangeFilters={data.setFilters}
            />
          </Flex>
        </Flex>

        <Table
          rowKey="id"
          size="small"
          showHeader={false}
          dataSource={data.tickets}
          columns={columns}
          loading={data.isLoading}
          pagination={paginationAnt}
          onChange={handleTableChange}
          onRow={row => {
            const to = `${location.pathname}/${row.id}`

            return {
              style: { cursor: 'pointer' },
              onClick: () => {
                navigate(to)
              },
            }
          }}
        />
      </Flex>
    </>
  )
}
